import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { ControlledTextField } from 'components/shared/ControlledFields';
import ControlledNumericField from 'components/shared/ControlledFields/ControlledNumericField';

export const AutoSendToFlexBlockSection = () => {
  const { t } = useTranslation();
  const { control } = useFormContext();

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 20 }}>
      <ControlledNumericField
        variant="outlined"
        label={t('cronJobs.form.minutesBeforeStart.')}
        name="config.minutesBeforeStart"
      />
      <ControlledTextField
        variant="outlined"
        label={t('cronJobs.form.functions')}
        control={control}
        name="config.functions"
      />
      <ControlledTextField
        variant="outlined"
        label={t('cronJobs.form.reason')}
        control={control}
        name="config.reason"
      />
    </div>
  );
};
